module.exports = __webpack_public_path__ + "static/media/scroll-down.86e44a26.svg";